import { Box, Card, styled, Typography, TextField } from "@mui/material";

interface StyledDivProps {
  isColumn?: boolean;
}

export const styleClasses = {
  overlay: "overlay",
  btnCloseDiv: "btnCloseDiv",
  paper: "paper",
  leftSection: "leftSection",
  mainContent: "mainContent",
  mainSection: "mainSection",
  headLine: "headLine",
  stockBase: "stockBase",
  productName: "productName",
  productCode: "productCode",
  productPrice: "productPrice",
  productType: "productType",
  stock: "stock",
  productTiles: "productTiles",
  imageProductCodeDiv: "imageProductCodeDiv",
  cardContentDiv: "cardContentDiv",
  outOfStock: "outOfStock",
  showBorderOnHover: "showBorderOnHover",
  belowInventoryThreshold: "belowInventoryThreshold",
  thresholdRange: "thresholdRange",
  emptyImageContainer: "emptyImageContainer",
  productGroupDiv: "productGroupDiv",
  productGroupComponentDiv: "productGroupComponentDiv",
  card: "card",
  productGroupCard: "productGroupCard",
  productGroupComponentCard: "productGroupComponentCard",
  productPriceContainer: "productPriceContainer",
  productPriceGroup: "productPriceGroup",
  publishControlWrapper: "publishControlWrapper",
  productQuantity: "productQuantity",
};

export const ImageContainer = styled("div")(() => ({
  width: "172px",
  height: "177px",
  "& .image": {
    width: "172px",
    height: "177px",
    margin: "auto",
    objectFit: "fill",
  },
  "& .productGroupImage": {
    width: "172px",
    height: "177px",
    objectFit: "fill",
    borderRadius: "5px",
  },
}));

export const ProductGroupComponentsImageContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center" /* Horizontally centers the container */,
  alignItems: "center",
  overflow: "hidden",
  margin: "auto",
  width: "89px",
  height: "91px",
  "& .image": {
    width: "69px",
    height: "70px",
    objectFit: "fill",
  },
}));

export const StyledDiv = styled("div")(() => ({
  [`&.${styleClasses.overlay}`]: {
    position: "absolute",
    top: "50%",
    left: 50,
    right: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999,
  },
  [`&.${styleClasses.btnCloseDiv}`]: {
    textAlign: "end",
    width: "100%",
    margin: "20px",
  },
}));

export const StyledTypography = styled(Typography)<StyledDivProps>(
  ({ theme, isColumn = false }) => ({
    [`&.${styleClasses.headLine}`]: {
      padding: theme.spacing(4, 0, 2.5, 0),
      fontSize: "16px",
      color: theme.palette.primary.main,
      fontWeight: "bold",
      textAlign: "center",
    },
    [`&.${styleClasses.stockBase}`]: {
      textAlign: "center",
      flex: 1,
      color: theme.palette.common.black,
      fontSize: "14px",
      fontWeight: 700,
      height: "36px",
      alignContent: "center",
      paddingTop: "9px",
    },
    [`&.${styleClasses.productName}`]: {
      display: "block",
      textAlign: "center",
      color: theme.palette.common.black,
      fontSize: isColumn ? "12px" : "16px",
      fontWeight: "bold",
      overflow: "hidden",
      textOverflow: "ellipsis", // Enable ellipsis for overflowed content
      direction: "ltr", // Make the ellipsis appear at the start
      whiteSpace: "nowrap", // Restrict text to a single line
      paddingTop: theme.spacing(1.25),
      paddingBottom: theme.spacing(0.375),
      maxWidth: "100%", // Set a maximum width for the text container
    },
    [`&.${styleClasses.productCode}`]: {
      color: theme.palette.common.black,
      fontSize: "12px",
      fontWeight: isColumn ? "normal" : 400,
      overflow: "hidden",
      textOverflow: "ellipsis", // Show ellipsis when text exceeds
      direction: "ltr", // Ellipsis at the start
      whiteSpace: "nowrap", // Restrict to one line only
      maxWidth: "100%",
      textAlign: "center",
    },
    [`&.${styleClasses.productPrice}`]: {
      color: theme.palette.common.black,
      fontSize: isColumn ? "12px" : "14px",
      fontWeight: "700",
      overflow: "hidden",
      textOverflow: "ellipsis", // Show ellipsis when text exceeds
      direction: "ltr", // Ellipsis at the start
      whiteSpace: "nowrap",
      maxWidth: "100%",
      textAlign: "center",
    },
    [`&.${styleClasses.stock}`]: {
      textAlign: "center",
      color: "white",
      fontSize: "13px",
      fontWeight: "600",
    },
    [`&.${styleClasses.productType}`]: {
      color: theme.palette.primary.main,
      fontSize: "16px",
      fontWeight: "700",
      overflow: "hidden",
      textOverflow: "ellipsis", // Show ellipsis when text exceeds
      direction: "ltr", // Ellipsis at the start
      whiteSpace: "nowrap", // Restrict to one line only
      paddingBottom: theme.spacing(3),
      maxWidth: "100%",
      textAlign: "center",
    },
    [`&.${styleClasses.productPriceGroup}`]: {
      fontSize: "12px",
      fontWeight: "700",
      color: theme.palette.common.black,
      paddingTop: "1px",
    },
  }),
);
export const ProductGroupStyledDiv = styled("div")<StyledDivProps>(
  ({ theme, isColumn = false }) => ({
    [`&.${styleClasses.productTiles}`]: {
      display: "flex",
      height: "90%",
      marginBottom: "12px",
    },
    [`&.${styleClasses.leftSection}`]: {
      margin: theme.spacing(0, 3.75, 1.25, 0.625),
      height: "100%",
      position: "sticky",
      top: 35,
    },
    [`&.${styleClasses.imageProductCodeDiv}`]: {
      width: isColumn ? "89px" : "150px",
      margin: "auto",
    },
    [`&.${styleClasses.mainContent}`]: {
      overflow: "hidden",
      padding: theme.spacing(0, 3, 3, 4),
      borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
      zIndex: 1000,
      backgroundColor: "white",
      minWidth: "45vw",
      minHeight: "65vh",
      [theme.breakpoints.down("md")]: {
        minWidth: "45%", // Adjust minWidth when screen size reaches 'sm'
        padding: theme.spacing(0, 3),
      },
      position: "relative",
      marginTop: 35,
    },
    [`&.${styleClasses.cardContentDiv}`]: { width: "100%", height: "80%" },
    [`&.${styleClasses.outOfStock}`]: {
      background: theme.palette.dangerColor.main,
      height: "20px",
      width: "inherit",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    [`&.${styleClasses.overlay}`]: {
      position: "fixed",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 99999,
      cursor: "pointer",
    },
    [`&.${styleClasses.showBorderOnHover}`]: {
      border: `1px solid ${theme.palette.common.black}`, // Using theme color for border
      "&:hover": {
        border: "1px solid" + theme.palette.primary.main,
      },
    },
    [`&.${styleClasses.stockBase}`]: {
      textAlign: "center",
      flex: 1,
      color: theme.palette.common.black,
      fontSize: "14px",
      fontWeight: 700,
      height: "36px",
      alignContent: "center",
      paddingTop: "9px",
    },

    [`&.${styleClasses.belowInventoryThreshold}`]: {
      background: theme.palette.neutral.yellow,
      height: "19px",
      width: "100%",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    [`&.${styleClasses.thresholdRange}`]: {
      background: theme.palette.grey[600],
      height: "19px",
      width: "100%",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    [`&.${styleClasses.emptyImageContainer}`]: {
      height: "142px",
      width: "142px",
      background: "lightgray",
      marginBottom: "5px",
      display: "flex",
    },

    [`&.${styleClasses.paper}`]: {
      backgroundColor: theme.palette.background.paper,
      width: "100%",
      minWidth: "65%",
      minHeight: "600px",
      height: "100%",
      position: "relative",
      display: "flex",
    },
    [`&.${styleClasses.productGroupDiv}`]: {
      height: "155px",
      width: "158px",
    },
    [`&.${styleClasses.productGroupComponentDiv}`]: {
      height: "89px",
      width: "91px",
    },
    [`&.${styleClasses.publishControlWrapper}`]: {
      paddingTop: "25px",
    },
  }),
);

export const StyledBox = styled(Box)(() => ({
  [`&.${styleClasses.mainSection}`]: {
    display: "flex",
    flexWrap: "wrap",
    gridGap: "24px",
    top: "20px",
    position: "relative",
  },
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${styleClasses.card}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "142px",
    border: "none !important",
  },
  [`&.${styleClasses.productGroupCard}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "172px",
    height: "279px",
    border: "none !important",
  },
  [`&.${styleClasses.productGroupComponentCard}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "142px",
    height: "312px",

    "&:hover": {
      border: "2px solid " + theme.palette.primary.main,
    },
  },
}));

export const StyledPriceDiv = styled("div")(() => ({
  [`&.${styleClasses.productPriceContainer}`]: {
    display: "flex",
    width: "100%",
    justifyContent: "space-evenly",
  },
}));

export const StyledQuantityInput = styled(TextField)(({ theme }) => ({
  [`&.${styleClasses.productQuantity}`]: {
    width: "30px",
    margin: "4px auto",
    display: "flex",
    height: "25px !important",
    "& .MuiInputBase-root": {
      height: "25px !important",
      fontSize: "12px",
      textAlign: "center",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.grey[300],
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.focusColor.main,
      },
    },
    "& .MuiInputBase-input": {
      textAlign: "center",
      padding: "6px 8px",
    },
  },
}));

export const useStyles = () => {
  return {
    divActionBtn: {
      textAlign: "end",
    },
    divNewActionBtn: {
      display: "flex",
    },
    rightSection: {
      position: "sticky",
      top: 0,
      marginLeft: "auto",
      minWidth: "150px",
      width: "auto",
      height: "74vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "flex-end",
      paddingLeft: "24px",
      paddingRight: "8px",
      overflowY: "auto",
      right: 0,
      "@media (max-width: 960px)": {
        minWidth: "200px",
      },
    },
  };
};
